import type { SortOption, SortValue } from '../components/primitives';

export const TASK_SORT_KEY = 'ss-os-task-sort';
export const DEFAULT_TASK_SORT: SortValue = { key: 'due', dir: 'asc' };
export const TASK_SORT_OPTIONS: SortOption[] = [
  { key: 'due', label: 'Due date', natural: 'asc', naturalLabel: 'soonest first' },
  { key: 'priority', label: 'Priority', natural: 'asc', naturalLabel: 'high first' },
  { key: 'project', label: 'Project', natural: 'asc', naturalLabel: 'A–Z' },
  { key: 'created', label: 'Created', natural: 'desc', naturalLabel: 'newest first' },
];

export function parseTaskSort(raw: string | null): SortValue {
  const [key, dir, extra] = (raw ?? '').split(':');
  return extra === undefined && TASK_SORT_OPTIONS.some(option => option.key === key) && (dir === 'asc' || dir === 'desc')
    ? { key, dir } : DEFAULT_TASK_SORT;
}

export function readTaskSort(): SortValue {
  try { return parseTaskSort(localStorage.getItem(TASK_SORT_KEY)); }
  catch { return DEFAULT_TASK_SORT; }
}

export function saveTaskSort(sort: SortValue): void {
  try { localStorage.setItem(TASK_SORT_KEY, `${sort.key}:${sort.dir}`); }
  catch { /* Sorting remains available when storage is blocked. */ }
}
